import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/pagedList'
import { NamedItem, NamedItemInt } from '../../../domain/common/namedItem'

export interface PagedCustomers extends PagedList<Customer> {}

export type CsiCustomersFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  q?: string
  productId?: string
  signupCompleted?: boolean
  hasActivePlanPeriod?: boolean
}

export interface Customer {
  companyId: string
  name: string
  signupCompleted: boolean
  createdAt: string
  products: NamedItem[]
  primaryAdmins: PrimaryAdminResponse[]
  recurlyCustomerUrl: string
  salesforceCustomerUrl: string
}

type PrimaryAdminResponse = {
  companyUserId: string
  product: NamedItemInt
  firstName: string
  lastName: string
}

const getCustomers = (filter: CsiCustomersFilter): Promise<PagedCustomers> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 10,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/Companies', filter)
}

export default getCustomers
